module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "ack01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "acknowledgeHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("I want to thank the following people who were invaluable in the creation of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rule Your Freakin’ Retirement")]), _vm._v(". Without them, there is simply no way you would be reading this now!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My agents, Frank R. Scatoni and Greg Dinkin at Venture Literary, who said, “Hey, we can sell that book!“ and then made it happen!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("St. Martin’s Press, who believed in me enough to give me another shot at Rulin’ something after the smashing success of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rule the Freakin’ Markets")]), _vm._v(" worldwide!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My editor at St. Martin’s Press, Phil Revzin, who has been ridiculously patient and supportive, and patient, and did I say patient? The dude has been a real trooper, and it’s been an honor working with him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jay Greenleaf, who without his research, his clarity, and his insights the book would be a hollow shell of what it is. He has been a friend and just a super resource.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Michael “Tiny“ Saul, who has worked with me for nine years at "), _c('a', {
    attrs: {
      "href": "http://trendfund.com",
      "target": "_blank"
    }
  }, [_vm._v("trendfund.com")]), _vm._v(" and who has helped us build one of the most influential and successful trading rooms the world has ever known. He’s also been an invaluable friend.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Doug Koval, who has been a friend and confidant since high school and who has helped when I needed the time to continue writing this beast of a book.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My staff at "), _c('a', {
    attrs: {
      "href": "http://trendfund.com",
      "target": "_blank"
    }
  }, [_vm._v("trendfund.com")]), _vm._v(": Sally Reppert, Ilene Hamilton, Scott, Debbie Lemel-Gross, Desiree Rowland, Scott Littlefield, et al., many of whom have been here since Day One of my journey in the markets and who have helped me in my own ability to retire. Carol "), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }), _vm._v("Guererro, who has taken such unreal care of my girls, she is an invaluable part of the family.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My daughters, Joelle Rebecca and Emma Grace, who are the absolute light of my life, without whom I would not know how rewarding life really is. They are magnificent and majestic and my babies.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My partners Elana Pianko and Stan Erdreich at Full Glass Films ("), _c('a', {
    attrs: {
      "href": "http://www.fullglassfilms.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.fullglassfilms.com")]), _vm._v(") who have helped me grow as an artist, and as a producer, and most of all as a person through thick and definitely through the thin of the film industry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I’d also like to thank my clients at "), _c('a', {
    attrs: {
      "href": "http://trendfund.com",
      "target": "_blank"
    }
  }, [_vm._v("trendfund.com")]), _vm._v(" and trendtrading "), _c('a', {
    attrs: {
      "href": "http://towin.com",
      "target": "_blank"
    }
  }, [_vm._v("towin.com")]), _vm._v(" who have done their own searching, as you will do yours. And, in that searching, they have helped me, as you are, by believing that there are other alternatives to making one’s financial and real life better—outside the box.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I’d also like to thank the following people for their support, their love, and their graciousness. They are warriors all: Jane Goldberg, Ph.D, Dr. Julian Neil, Bill McCarthy, Bill Marley, Mark Perez, Bonnie Rabin, Esq., Dr. Richard Rosenthal, Dr. Lori Weintrob, Rory Parness, Merri Siegel, Jessica Bayer, Stephanie Perronne, Sharon Dastur, Zena Burns, Jeff Telvi, and Giulianna Telvi. My nieces and my nephew: Corinne, Ariella, Shayna, Olivia, Juliet, Maya, Charlotte, and Noah")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you,")]), _vm._v(" because if no one reads your book, it’s not worth writing!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60836a5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ruleyourfreakinretirement_ack01.vue
// module id = 75
// module chunks = 0